<template>
  <div class="bg-card border border-border rounded-lg flex shadow-sm flex-col transition-all duration-200 hover:shadow-md hover:-translate-y-1">
    <div class="p-4">
      <div class="flex flex-col items-center text-center">
        <img v-if="talentPool.company_logo" :src="talentPool.company_logo" class="h-12 mb-3" alt="Company Logo" />
        <h2 v-else class="text-lg font-semibold text-gray-800">{{ talentPool.company_name }}</h2>
      </div>
    </div>

    <div class="p-5 flex-grow flex flex-col">
      <div class="mb-3">
        <p class="text-sm font-medium text-newPrimary">{{ talentPool.project_id ? 'Project Talent Pool' : 'BAU Talent Pool' }}</p>
        <p v-if="talentPool.project_id" class="text-sm text-gray-500">{{ talentPool.project_name }}</p>
      </div>

      <h3 class="text-xl font-bold text-gray-900 mb-4">{{ talentPool.title }}</h3>

      <div class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-gray-600">
        <div class="flex items-center gap-2">
          <MapPin class="h-4 w-4 text-newPrimary flex-shrink-0" />
          <span>{{ talentPool.location }}</span>
        </div>
        <div class="flex items-center gap-2">
          <DollarSign class="h-4 w-4 text-newPrimary flex-shrink-0" />
          <span>{{ talentPool.budget || 'Not Disclosed' }}</span>
        </div>
        <div class="flex items-center gap-2">
          <Briefcase class="h-4 w-4 text-newPrimary flex-shrink-0" />
          <span>{{ talentPool.work_type }}</span>
        </div>
        <div class="flex items-center gap-2">
          <Clock class="h-4 w-4 text-newPrimary flex-shrink-0" />
          <span>{{ formattedTimelineDate }}</span>
        </div>
      </div>

      <div class="flex flex-wrap gap-2 mt-auto pt-4">
        <template v-if="talentPool.qualifications && talentPool.qualifications.length > 0">
          <span v-for="skill in talentPool.qualifications" :key="skill" class="bg-newPrimary text-white text-xs font-semibold px-2.5 py-0.5 rounded-full">
            {{ skill }}
          </span>
        </template>
        <template v-else>
          <span class="text-xs text-gray-400 italic">No specific skills listed.</span>
        </template>
      </div>
    </div>

    <div class="p-3">
      <div class="flex items-center gap-3">
        <router-link
        class="flex-1"
          :to="{ name: 'TalentCommunityDetail', params: { id: talentPool.id } }"
        >
          <Button
            variant="secondary"
            class="w-full"
          >
            View Details
          </Button>
        </router-link>

        <Button
          v-show="!talentPool.applicationStatus"
          @click="handleApplyClick"
          variant="default"
          class="flex-1 bg-newPrimary text-white hover:brightness-110"
        >
          Quick Application
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Button } from '@/components/marketplace/ui';
import { useTalentPoolsStore } from '@/stores/talentPoolsStore';
import { Circle, CheckCircle, Clock, MapPin, DollarSign, Briefcase, Calendar } from 'lucide-vue-next';
import { formatHiringTimeline } from '@/utils/formatters';

const props = defineProps({
  talentPool: {
    type: Object,
    required: true,
  }
});

const talentPoolsStore = useTalentPoolsStore();

// This computed property checks the global loading state for this specific card
const isLoading = computed(() => talentPoolsStore.actionLoadingId === props.talentPool.id);

// Click Handlers
const handleApplyClick = () => {
  if (!props.talentPool.applicationStatus) {
    talentPoolsStore.applyToTalentPool(props.talentPool.id);
  }
};


const formattedTimelineDate = computed(() =>
  formatHiringTimeline(
    props.talentPool.hiring_timeline,
    props.talentPool.timeline_date,
    props.talentPool.timeline
  )
);

</script>
